import { Component, effect, input } from '@angular/core';
import { TagsGroupListComponent } from './components/tags-group-list/tags-group-list.component';
import { SingleTagsComponent } from './components/single-tags/single-tags.component';

@Component({
  selector: 'app-tags',
  standalone: true,
  imports: [
    TagsGroupListComponent,
    SingleTagsComponent
  ],
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
})
export class TagsComponent   {
  public tags: any = input.required<any>();

  public isGroupTagsAndSingleTags(): boolean {
    return (this.tags().groups && this.tags().groups.length > 0) && 
            (this.tags().singleTags && this.tags().singleTags.length > 0)
  }

  public isOnlyGroupTags(): boolean {
    return (this.tags().groups && this.tags().groups.length > 0) && 
            (!this.tags().singleTags || this.tags().singleTags.length === 0);
  }

  public isOnlySingleTags(): boolean {
    return (!this.tags().groups || this.tags().groups.length === 0) && 
            (this.tags().singleTags && this.tags().singleTags.length > 0);
  }
}
